package com.shadowings.gero.data.lessons.chapter11

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_recap_frasi_pseudoverbali_1
import gero.composeapp.generated.resources.exp_content_recap_frasi_pseudoverbali_2
import gero.composeapp.generated.resources.exp_content_recap_frasi_pseudoverbali_3
import gero.composeapp.generated.resources.exp_content_recap_frasi_pseudoverbali_4
import gero.composeapp.generated.resources.exp_content_recap_frasi_pseudoverbali_5
import gero.composeapp.generated.resources.exp_content_recap_frasi_pseudoverbali_6
import gero.composeapp.generated.resources.exp_content_recap_frasi_pseudoverbali_7
import gero.composeapp.generated.resources.exp_content_recap_frasi_pseudoverbali_8
import gero.composeapp.generated.resources.exp_title_recap_frasi_pseudoverbali

fun getRecapFrasiPseudoverbaliContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_recap_frasi_pseudoverbali,
            content = Res.string.exp_content_recap_frasi_pseudoverbali_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_frasi_pseudoverbali,
            content = Res.string.exp_content_recap_frasi_pseudoverbali_2,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_frasi_pseudoverbali,
            content = Res.string.exp_content_recap_frasi_pseudoverbali_3,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_frasi_pseudoverbali,
            content = Res.string.exp_content_recap_frasi_pseudoverbali_4,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_frasi_pseudoverbali,
            content = Res.string.exp_content_recap_frasi_pseudoverbali_5,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_frasi_pseudoverbali,
            content = Res.string.exp_content_recap_frasi_pseudoverbali_6,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_frasi_pseudoverbali,
            content = Res.string.exp_content_recap_frasi_pseudoverbali_7,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_frasi_pseudoverbali,
            content = Res.string.exp_content_recap_frasi_pseudoverbali_8,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
    )
}
